import type { MarketingDocContent } from '../types';

/** Migrated structure from legacy visime.ch Nutzungsbedingungen (app terms; WP export unavailable). */
export const nutzungsbedingungenDe: MarketingDocContent = {
  slug: 'nutzungsbedingungen',
  title: 'Nutzungsbedingungen',
  updated: '2026-03-22',
  description: 'Allgemeine Bedingungen für die Nutzung der VisiMe App und Web-Dienste.',
  sections: [
    {
      heading: '1. Geltungsbereich',
      paragraphs: [
        'Diese Nutzungsbedingungen regeln die Nutzung der VisiMe mobile App und der zugehörigen Web-Angebote von VisiMe AG bzw. LEBO Apps GmbH als technischem Dienstleister.',
        'Mit Registrierung oder Nutzung des Dienstes akzeptieren Sie diese Bedingungen sowie die Datenschutzerklärung.',
      ],
    },
    {
      heading: '2. Leistungsbeschreibung',
      paragraphs: [
        'VisiMe ermöglicht die Erstellung und Verwaltung digitaler Visitenkarten (VISI), standortbezogene Sichtbarkeit, Verknüpfung externer Kontakt- und Social-Media-Kanäle sowie die Suche und Organisation von VISI-Profilen über ein ME-Konto.',
        'Funktionsumfang und Verfügbarkeit können je nach Abonnement, Plattform und Region variieren.',
      ],
    },
    {
      heading: '3. Konto und Pflichten',
      paragraphs: ['Sie sind verpflichtet, wahrheitsgemässe Angaben zu machen, Zugangsdaten vertraulich zu behandeln und den Dienst nicht missbräuchlich zu nutzen.'],
      list: [
        'Keine rechtswidrigen, irreführenden oder rechtsverletzenden Inhalte in VISI-Profilen',
        'Keine automatisierte Massenabfrage oder Störung der Plattform',
        'Einhaltung geltender Datenschutz- und Telekommunikationsvorschriften bei veröffentlichten Kontaktdaten',
      ],
    },
    {
      heading: '4. Abonnements und Zahlungen',
      paragraphs: [
        'Kostenpflichtige VISI-Abonnements werden über den Apple App Store oder Google Play abgewickelt; Preise und Laufzeiten werden in der App angezeigt.',
        'Kündigung und Verwaltung erfolgen über die jeweilige Store-Kontoverwaltung, sofern nicht anders angegeben.',
        'Probezeiten und Preisänderungen werden in der App kommuniziert.',
      ],
    },
    {
      heading: '5. Sichtbarkeit und Standort',
      paragraphs: [
        'Sie entscheiden in der App über die Sichtbarkeit Ihres VISI und optional über standortbasierte Anzeige (GPS oder feste Adresse).',
        'Bei GPS-basierter Anzeige kann die Entfernung aus Sicherheitsgründen gerundet dargestellt werden.',
      ],
    },
    {
      heading: '6. Haftung und Verfügbarkeit',
      paragraphs: [
        'Der Dienst wird «wie besehen» bereitgestellt. Soweit gesetzlich zulässig, haften wir nicht für indirekte Schäden, entgangenen Gewinn oder Ausfälle Dritter (Stores, Netzbetreiber).',
        'Wartungsfenster und Updates können die Verfügbarkeit vorübergehend einschränken.',
      ],
    },
    {
      heading: '7. Kündigung',
      paragraphs: [
        'Sie können Ihr Konto gemäss den Funktionen in der App löschen. Wir können Konten bei schwerwiegenden Verstössen gegen diese Bedingungen sperren oder beenden.',
      ],
    },
    {
      heading: '8. Anwendbares Recht',
      paragraphs: [
        'Es gilt schweizerisches Recht, unter Ausschluss kollisionsrechtlicher Bestimmungen, soweit zwingende Verbraucherschutzvorschriften nicht entgegenstehen.',
        'Kontakt: support@visime.com',
      ],
    },
  ],
};
